export enum DriverUsage {
	WORK = 'WORK',
	PERSONAL = 'PERSONAL',
	BOTH = 'BOTH',
}
